import { api } from '../../api'
import type {
  NotificationCountFilters,
  NotificationCountResponse,
  NotificationFilters,
  NotificationsResponse,
  UpdateNotificationRequest,
} from '../../../types/notification.types'

export type {
  Notification,
  NotificationCountFilters,
  NotificationCountResponse,
  NotificationFilters,
  NotificationsResponse,
  UpdateNotificationRequest,
} from '../../../types/notification.types'

export const getNotifications = async (params: NotificationFilters): Promise<NotificationsResponse> => {
  const res = await api.get<NotificationsResponse>('notifications/', { params })
  return res.data
}

export const getNotificationCount = async (params: NotificationCountFilters): Promise<NotificationCountResponse> => {
  const res = await api.get<NotificationCountResponse>('notifications/count/', { params })
  return res.data
}

export const patchNotification = async (data: UpdateNotificationRequest): Promise<void> => {
  await api.patch(`notifications/${data.id}/`, data)
}

export const patchAllNotifications = async (): Promise<void> => {
  await api.patch('notifications/mark_all_read/')
}
